import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Checkbox from '@mui/material/Checkbox'
import { IImportErrorDelete } from '@/@data'
import { useState, useEffect, useImperativeHandle, forwardRef } from 'react'

interface Column {
  id: 'id' | 'row' | 'first_name' | 'employee_id' | 'check'
  label: string
  minWidth?: number
  align?: 'right'
  format?: (value: number) => string
}

const columns: readonly Column[] = [
  { id: 'id', label: '#', minWidth: 50 },
  { id: 'row', label: 'ID', minWidth: 70 },
  {
    id: 'first_name',
    label: 'EMPLOYEE NAME',
    minWidth: 200
  },
  {
    id: 'employee_id',
    label: 'EMPLOYEE CODE',
    minWidth: 200
  },
  {
    id: 'check',
    label: 'CREATE USER',
    minWidth: 150
  }
]

export interface InvalidEmployeeDeleteTableRef {
  getCheckedUserIds: () => number[]
}

const InvalidEmployeeDeleteTable = forwardRef<InvalidEmployeeDeleteTableRef, { data: IImportErrorDelete[] }>(
  ({ data }, ref) => {
    const [checkedItems, setCheckedItems] = useState<Set<number>>(new Set())

    useEffect(() => {
      // Initialize checked items based on data.check field
      const initialChecked = new Set<number>()

      data.forEach(item => {
        if (item.check === 'true' && item.id) {
          initialChecked.add(item.id)
        }
      })

      setCheckedItems(initialChecked)
    }, [data])

    useImperativeHandle(ref, () => ({
      getCheckedUserIds: () => Array.from(checkedItems)
    }))

    const handleCheckboxChange = (userId: number, checked: boolean) => {
      const newChecked = new Set(checkedItems)

      if (checked) {
        newChecked.add(userId)
      } else {
        newChecked.delete(userId)
      }

      setCheckedItems(newChecked)
    }

    console.log('Checked Items:', Array.from(checkedItems))

    return (
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label='sticky table'>
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                return (
                  <TableRow hover role='checkbox' tabIndex={-1} key={row.id || index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.first_name || '-'}</TableCell>
                    <TableCell>{row.employee_id || '-'}</TableCell>
                    <TableCell>
                      <Checkbox
                        checked={checkedItems.has(row.id)}
                        onChange={e => handleCheckboxChange(row.id, e.target.checked)}
                        sx={{
                          color: '#28C76F',
                          '&.Mui-checked': {
                            color: '#28C76F'
                          }
                        }}
                      />
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }
)

InvalidEmployeeDeleteTable.displayName = 'InvalidEmployeeDeleteTable'

export default InvalidEmployeeDeleteTable
